import _get from "lodash/get";
import { FinancingType } from "../../../../../constants";
import { RootState, GetCustomerType, ContentfulQueueElement } from "../../../../../models";

export const getEnableCheckoutQueue = (state: RootState): boolean =>
    _get(state, "queue.data.enableCheckoutQueue", false);
export const getSku = (state: RootState) => _get(state, "queue.data.sku", "");
export const getFinancingType = (state: RootState): FinancingType => _get(state, "queue.data.financingType");
export const getFinancingDuration = (state: RootState) => _get(state, "queue.data.financingDuration", "");
export const getDiscountCode = (state: RootState) => _get(state, "queue.data.discountCode", "");
export const getPricePlan = (state: RootState) => _get(state, "queue.data.pricePlan");
export const getReturnUrl = (state: RootState) => _get(state, "queue.data.returnUrl", "");
export const getCustomerTypeGet = (state: RootState): GetCustomerType => _get(state, "queue.data.customerTypeGet");
export const getQueueElements = (state: RootState): ContentfulQueueElement[] | undefined =>
    _get(state, "queue.queueElements");
